import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'

const Popup = (props) =>{

  const {title, children, openPopupVar, setOpenPopupMet} = props;

  return(
    <Dialog open ={openPopupVar}>
     
      <DialogContent dividers>
        {children}
      </DialogContent>
    </Dialog>
  )

}

export default Popup;